module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy.44a793a2.md";